import { CarouselComponent, CarouselModule } from 'ngx-owl-carousel-o';
import { DirectionService } from '@app/_services/direction.service';
import { Component, OnInit, Input, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgFor, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-modal-gallery',
    templateUrl: './modal-gallery.component.html',
    styleUrls: ['./modal-gallery.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatIconModule, CarouselModule, NgFor, NgClass, ExtendedModule]
})
export class ModalGalleryComponent implements OnInit, AfterViewInit {

    @Input() selectedImage;
    @Input() items = [];
    @Input() imageRatio: 'ratio-1by1' | 'ratio-16by9' = 'ratio-1by1';
    @Input() width;
    @Input() selectedIndex;

    changeimage(selected: string, index){
        this.selectedImage = selected;
        this.selectedIndex = index;
    }

    modalWidth;

    constructor(
        private modalService: BsModalService,
        public bsModalRef: BsModalRef,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        public dir: DirectionService
    ) { }

    @ViewChild('thumbCarousel', { read: CarouselComponent }) thumbnailsCarousel: CarouselComponent;

    carouselOptions: any = {
        //lazyLoad:true,
        items: 1,
        margin: 14,
        nav: false,
        dots: false,
        loop: false,
        skip_validateItems : true,
        //stagePadding: 1,
        rtl: this.dir.isRTL()
    };

    ngAfterViewInit(): void {
        this.modalWidth = document.getElementById('modal');
        this.modalWidth
        //this.thumbnailsCarousel.to(this.selectedImage)
        window
    }

    changed(event) {
        event
    }

    ngOnInit(): void {
    }

    nextImage(carousel: CarouselComponent) {
        if (this.dir.isLTR()) {
            carousel.next();
            this.nextSelected();
        } else {
            carousel.prev();
            this.prevSelected();
        }
    }

    prevImage(carousel: CarouselComponent) {
        if (this.dir.isLTR()) {
            carousel.prev();
            this.prevSelected();
        } else {
            carousel.next();
            this.nextSelected();
        }
    }

    nextSelected() {
        //let newIndex = this.selectedIndex +1;
        if (this.selectedIndex + 1 < this.items?.length) this.selectedIndex += 1;
        else this.selectedIndex = 0;
        this.selectedImage = this.items[this.selectedIndex].image;
    }

    prevSelected() {
        //let newIndex = this.selectedIndex - 1;
        if (this.selectedIndex - 1 >= 0) this.selectedIndex -= 1;
        else this.selectedIndex = this.items?.length;
        this.selectedImage = this.items[this.selectedIndex].image;
    }
}
